{
  "dashboard": {
    "column": {
      "title": "Title",
      "todo": "To do"
    },
    "header": "Dashboard",
    "myTodos": {
      "title": "My todos",
      "itemsCount": "{{count}} todos",
      "empty": "No todos at the moment",
      "tooltips": {
        "reviewStep": "You have a document to review",
        "approveStep": "A document requires your approval",
        "publishDocument": "Workflow complete, ready to publish",
        "rejectedStepByUser": "{{name}} rejected a workflow step",
        "rejectedStepByYou": "You rejected a workflow step",
        "rejectedStepFallback": "A workflow step was rejected",
        "moveForward": "Step complete, next step can be activated",
        "stepMissingUsers": "Assign users to step {{stepName}}",
        "readDocument": "You have a document to read"
      },
      "dateLabels": {
        "published": "Published",
        "adopted": "Adopted",
        "date": "Date",
        "stepDueAt": "Step response date",
        "artifactReviewTo": "Scheduled end date"
      }
    },
    "ongoing": {
      "workflows": "Ongoing workflows"
    },
    "publish": {
      "title": "Document acceptance status"
    },
    "pinnedDocuments": {
      "title": "Pinned documents",
      "addTitle": "Add pinned document",
      "addDescription": "The document will be shown on the dashboard for all users that have access to it",
      "editTitle": "Edit pinned document",
      "editDescription": "Update the dashboard description for \"{{title}}\"",
      "document": "Document",
      "documentPlaceholder": "Select document",
      "description": "Short description",
      "descriptionPlaceholder": "Write a short dashboard description",
      "removeDialog": {
        "title": "Remove pinned document",
        "description": "Remove \"{{title}}\" from pinned documents?",
        "button": "Remove"
      },
      "toasts": {
        "added": "Document pinned",
        "updated": "Pinned document updated",
        "removed": "Pinned document removed",
        "removing": "Removing pinned document..."
      }
    },
    "upcoming": {
      "workflows": "Upcoming workflows"
    },
    "createDocument": {
      "uploadFile": "Upload file",
      "fromExistingDocument": "From an existing document",
      "sourceDocument": "Source document",
      "searchSourceDocument": "Search and select a document",
      "sourceVersion": "Version to copy",
      "selectSourceVersion": "Select a version",
      "noReadableSources": "There are no available documents to use as a template.",
      "file": "File",
      "fileType": "Type",
      "fileTypeDescription": "Please note that editing Office documents requires an active Microsoft 365 license",
      "supportedFormats": "Supported file formats:",
      "errorCreating": "Error creating document"
    },
    "userManual": {
      "getStarted": "Get started with North House by reading the",
      "userGuide": "User guide"
    }
  }
}
